import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed7d742c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "booking-cancel-success-page" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"header-wrapper\" data-v-ed7d742c><div class=\"w-100\" data-v-ed7d742c><h1 class=\"title-2 cancel-title\" data-v-ed7d742c> キャンセルのご対応ありがとうございます。 下記日時のキャンセルを承りました。 </h1></div><div class=\"w-100\" data-v-ed7d742c><h1 class=\"text-2 cancel-title\" data-v-ed7d742c>またのご来院お待ちしております。</h1></div></div>", 1)
const _hoisted_3 = { class: "content-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title-2 content-title" }, "予約内容", -1))
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "text-value" }
const _hoisted_7 = {
  key: 0,
  class: "row-content inline-block"
}
const _hoisted_8 = {
  key: 1,
  class: "row-content inline-block"
}
const _hoisted_9 = { class: "label" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "オプションメニュー：", -1))
const _hoisted_11 = { class: "m-0 p-0" }
const _hoisted_12 = { class: "text-2" }
const _hoisted_13 = { class: "text-value total-price" }
const _hoisted_14 = { class: "footer-wrapper" }

import { onBeforeMount, computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { CustomerServices } from "@/clinic/services";
import moment from "moment";
import NumberUtils from "@/clinic/utils/number-utils";
import liff from "@line/liff";
import DateTimeUtils from "../utils/date-time-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingCancelSuccess',
  setup(__props) {

const store = useStore();
const route = useRoute();
const bookingInfo = ref();

onBeforeMount(async () => {
  const bookingId = route.params.booking_id;
  const lineAccountId = store.getters["line_account/id"];
  const clinicId = store.getters["line_account/clinicId"];
  const params = { line_account_id: lineAccountId, clinic_id: clinicId };
  const bookingDetail = await CustomerServices.getBookingDetail(bookingId, params);
  bookingInfo.value = bookingDetail.data.value;
});

const backToTop = () => {
  liff.closeWindow();
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, [
        _createTextVNode(" 予約日時： "),
        _createElementVNode("span", _hoisted_6, [
          (bookingInfo.value?.start_time)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(DateTimeUtils).formatDate(bookingInfo.value?.start_time, "")[0]), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "承認待ち"))
        ])
      ]),
      _createElementVNode("p", _hoisted_9, [
        _createTextVNode(" メニュー： "),
        _createElementVNode("span", null, _toDisplayString(bookingInfo.value?.medical_menu.name), 1)
      ]),
      _hoisted_10,
      _createElementVNode("ul", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookingInfo.value?.medical_options, (medical_option) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "pb-2 option_menu",
            key: medical_option
          }, _toDisplayString(medical_option?.name), 1))
        }), 128))
      ]),
      _createElementVNode("h1", _hoisted_12, [
        _createTextVNode(" 金額： "),
        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(NumberUtils).formatJPCurrency(bookingInfo.value?.total_amount)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_Button, {
        class: "back-to-top-btn",
        onClick: backToTop
      }, {
        default: _withCtx(() => [
          _createTextVNode("閉じる")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})